import * as React from 'react'
import DialogTitle from '@mui/material/DialogTitle'
import Button from '@mui/material/Button'

import Grid from '@mui/material/Grid'

import Container from '@mui/material/Container'
import DialogContent from '@mui/material/DialogContent'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import DialogContentText from '@mui/material/DialogContentText'
import DialogActions from '@mui/material/DialogActions'
import Dialog from '@mui/material/Dialog'
import LoadingButton from '@mui/lab/LoadingButton'
import Link from '@mui/material/Link'
import Paper from '@mui/material/Paper'
import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'

import Stepper from '@mui/material/Stepper'
import Step from '@mui/material/Step'
import StepLabel from '@mui/material/StepLabel'
import StepButton from '@mui/material/StepButton'

import Typography from '@mui/material/Typography'

import ArrowForwardIcon from '@mui/icons-material/ArrowForwardOutlined'
import TextFieldsIcon from '@mui/icons-material/TextFields'
import MicNoneIcon from '@mui/icons-material/MicNone'
import Tooltip from '@mui/material/Tooltip'
import InputAdornment from '@mui/material/InputAdornment'
import AddLinkIcon from '@mui/icons-material/AddLink'
import UploadFileOutlinedIcon from '@mui/icons-material/UploadFileOutlined'
import TableViewOutlinedIcon from '@mui/icons-material/TableViewOutlined'
import ImportExportIcon from '@mui/icons-material/ImportExport'
import CloudSyncOutlinedIcon from '@mui/icons-material/CloudSyncOutlined'
import LanguageIcon from '@mui/icons-material/Language'
import SearchIcon from '@mui/icons-material/Search'
import TrendingUpIcon from '@mui/icons-material/TrendingUp'
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome'
import GridOnIcon from '@mui/icons-material/GridOn'
import OndemandVideoOutlinedIcon from '@mui/icons-material/OndemandVideoOutlined'
import BiotechOutlinedIcon from '@mui/icons-material/BiotechOutlined'
import HubOutlinedIcon from '@mui/icons-material/HubOutlined'

import EditableSelect from '../EditableSelect'
import TextField from '@mui/material/TextField'

import {
    useContextsStore,
    selectOwnedContexts,
} from '../../stores/useContextsStore'
import { UserContext } from '../../UserContext'

import { useTheme } from '@mui/material/styles'

import { SubImportContext } from './SubImportContext'
import { DialogsContext, DialogsProvider } from '../../DialogsContext'

import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import FormHelperText from '@mui/material/FormHelperText'
import FormLabel from '@mui/material/FormLabel'
import FormControlLabel from '@mui/material/FormControlLabel'

import Switch from '@mui/material/Switch'

import axios from 'axios'
import qs from 'qs'

import {
    slugifyString,
    convertGPTResponsesToArray,
    isValidUrl,
    getUrlTypeAndCode,
} from '../../utils/index'

import { sendToAnalytics } from '../../Analytics'
import { useZustand } from '../../hooks/useZustand'
import { isVoiceDictationSupported } from '../../hooks/useVoiceDictation'
import VoiceSourceMenu from '../VoiceInput/VoiceSourceMenu'
import { importErrorMessage } from './importError'


const steps = ['Start', 'Sources', 'Settings', 'Results']

export default function MainImportDialog({
    presetContext = '',
    open,
    onClose,
}) {
    const theme = useTheme() // hook to get the current theme

    const {
        activeImportDialog,
        setActiveImportDialog,
        setBackLinkDialog,
        presetSearchString,
        setPresetSearchString,
        openImportDialog,
        closeImportDialog,
    } = React.useContext(DialogsContext)

    // Shared across all import sources so the typed query persists when switching
    const searchString = presetSearchString
    const setSearchString = setPresetSearchString

    const {
        activeSubImportDialog,
        setActiveSubImportDialog,
    } = React.useContext(SubImportContext)

    const [selectedContext, setSelectedContext] = React.useState(presetContext)

    const [errorMessage, setErrorMessage] = React.useState(null)

    const [importError, setImportError] = React.useState(null)

    const [completedSteps, setCompletedSteps] = React.useState([])

    const [visitedContext, setVisitedContext] = React.useState(false)

    const [numberOfResults, setNumberOfResults] = React.useState('10')

    const [modelToUse, setModelToUse] = React.useState('gpt4')

    const [hideSearchTerms, setHideSearchTerms] = React.useState(true)

    const [advancedSettings, setAdvancedSettings] = React.useState(false)

    const [fromInsideContext, setFromInsideContext] = React.useState(false)

    const [activeInputPanel, setActiveInputPanel] = React.useState(false)

    const { username } = React.useContext(UserContext)

    React.useEffect(() => {
        setActiveSubImportDialog(false)
        setActiveImportDialog('import')
        setBackLinkDialog('backLink')
    }, [])

    const contexts = useContextsStore(selectOwnedContexts)
    const contextNames = contexts.map(c => c.name)

    const [activeStep, setActiveStep] = React.useState(0)
    const [skipped, setSkipped] = React.useState(new Set())

    const isStepOptional = step => {
        return step === 1
    }

    const isStepSkipped = step => {
        return skipped.has(step)
    }

    const handleNext = () => {
        let newSkipped = skipped
        if (isStepSkipped(activeStep)) {
            newSkipped = new Set(newSkipped.values())
            newSkipped.delete(activeStep)
        }

        setActiveStep(prevActiveStep => prevActiveStep + 1)
        setSkipped(newSkipped)
    }

    const submitDataForm = () => {
        const redirectUrl = fromInsideContext
            ? ``
            : `/${username}/${selectedContext}/edit`

        const dataToSend = {
            context: selectedContext,
            addedContexts: selectedContext,
            mode: modelToUse === 'gpt4' ? 'gptchat' : 'continue',
            entry: { body: searchString },
            addedCategories: `[ideas]`,
            redirectUrl: redirectUrl,
        }

        const dataAsForm = qs.stringify(dataToSend)

        axios
            .post(`/post`, dataAsForm, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded', // Sending as URL-encoded form data
                },
            })
            .then(response => {
                if (response.data.redirectUrl) {
                    // If you're using window.location
                    window.location.href = response.data.redirectUrl

                    // Or, if you're using React Router's history (assuming you have access to the history object)
                    // history.push(response.data.redirectUrl);
                } else {
                    console.error(`Did't receive any response from the server.`)
                    if (response.data.error) {
                        setErrorMessage(
                            typeof response.data.error == 'object'
                                ? response.data.error.error ||
                                      JSON.stringify(response.data.error)
                                : response.data.error
                        )
                        setImportError(response.data.error)
                        setActiveStep(1)
                    }
                }
            })
            .catch(error => {
                // Handle the error here
                console.error('Received the following error', error)
                setErrorMessage(importErrorMessage(error))
                setImportError(response.data.error)
            })
    }

    const handleBack = () => {
        setActiveStep(prevActiveStep => prevActiveStep - 1)
    }

    const handleNumberOfResultsChange = event => {
        setNumberOfResults(event.target.value)
    }

    const handleSearchStringChange = event => {
        setSearchString(event.target.value)
    }

    const handleSearchLanguageChange = event => {
        setSearchLanguage(event.target.value)
    }

    const handleSearchCountryChange = event => {
        setSearchCountry(event.target.value)
    }

    // Only a graph page has a statements panel to dictate into; on /apps
    // the same dialog offers no mic.
    const currentContext = useZustand(state => state.currentContext)
    const canDictate = !!currentContext && isVoiceDictationSupported()

    const [voiceMenuAnchor, setVoiceMenuAnchor] = React.useState(null)

    // Hands over to the statements panel: the add form opens (the
    // requestAddStatement intent) and starts listening right away (the
    // requestVoiceInput intent, consumed by StatementTextarea).
    const handleVoiceSource = ({ source, includeMic }) => {
        onClose()
        useZustand.getState().requestAddStatement()
        useZustand.getState().requestVoiceInput({ source, includeMic })
        sendToAnalytics({
            userId: username,
            event: 'choose_content_import_type',
            data: { importType: 'voiceInput', voiceSource: source },
        })
    }

    const voiceInputButton = canDictate && (
        <Tooltip title="Voice input: dictate, or transcribe a call or video">
            <IconButton
                size="small"
                aria-label="Dictate statements"
                aria-haspopup="menu"
                // Keep the text field focused so its onBlur doesn't collapse
                // the panel (and unmount this button) before the click lands.
                onMouseDown={event => event.preventDefault()}
                onClick={event => {
                    event.stopPropagation()
                    setVoiceMenuAnchor(event.currentTarget)
                }}
                sx={{ color: '#6688ff' }}
            >
                <MicNoneIcon />
            </IconButton>
        </Tooltip>
    )

    const openTextEditImport = type => {
        if (type == 'shortTextImport') {
            setActiveInputPanel('shortTextImport')
        } else {
            setActiveSubImportDialog({})
            setActiveImportDialog(type)
        }

        sendToAnalytics({
            userId: username,
            event: 'choose_content_import_type',
            data: { importType: type },
        })
    }

    React.useEffect(() => {
        if (activeStep != 1) return
        if (activeInputPanel != 'shortTextImport') return

        if (!searchString) {
            setErrorMessage(
                `Please, add a text that you would like to analyze and visualize.`
            )
            setActiveStep(0)
            return
        }

        const numberOfWords = searchString.split(' ')

        const urlIsValid = isValidUrl(searchString)

        if (urlIsValid) {
            const urlTypeAndCode = getUrlTypeAndCode(searchString)

            setPresetSearchString(searchString)
            switch (urlTypeAndCode.type) {
                case 'amazon':
                    setActiveImportDialog('amazonReviews')
                    break
                case 'youtube':
                    setActiveImportDialog('youtubeSubtitles')
                    break
                case 'youtubeChannel':
                case 'youtubePlaylist':
                    setActiveImportDialog('youtubeChannel')
                    break
                case 'wikipedia':
                    setActiveImportDialog('urls')
                    break
                case 'twitter':
                    setActiveImportDialog('twitter')
                    break
                case 'rss':
                    setActiveImportDialog('rss')
                    break
                default:
                    setActiveImportDialog('urls')
                    break
            }
            setBackLinkDialog('backLinkToLinks')
            return
        }

        if (numberOfWords.length > 0 && numberOfWords.length < 16) {
            setPresetSearchString(searchString)
            setActiveImportDialog('shortTextImport')
            setBackLinkDialog('backLink')
            return
        }

        if (numberOfWords.length >= 16) {
            setPresetSearchString(searchString)
            setActiveImportDialog('textEditor')
            return
        }
    }, [activeStep])

    const handleStep = step => {
        setActiveStep(step)
    }

    return (
        <>
            <Dialog
                open={open}
                onClose={onClose}
                fullWidth={true}
                maxWidth="lg"
            >
                <DialogTitle
                    sx={{
                        padding: 4,
                        color: theme => theme.palette.text.primary,
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    }}
                >
                    {'Choose the type of content to analyze'}
                    <IconButton
                        edge="end"
                        color="inherit"
                        onClick={onClose}
                        aria-label="close"
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <Stepper
                    activeStep={activeStep}
                    sx={{ paddingLeft: 4, paddingRight: 4, paddingTop: 2 }}
                >
                    {steps.map((label, index) => {
                        const stepProps = {}
                        const labelProps = {}
                        // if (isStepOptional(index)) {
                        //     labelProps.optional = (
                        //         <Typography variant="caption">
                        //             Optional
                        //         </Typography>
                        //     )
                        // }
                        if (isStepSkipped(index)) {
                            stepProps.completed = false
                        }
                        return (
                            <Step key={label} {...stepProps}>
                                <StepButton
                                    onClick={() => handleStep(index)}
                                    completed={(
                                        completedSteps.indexOf(index) >= 0
                                    ).toString()}
                                >
                                    <StepLabel
                                        {...labelProps}
                                        sx={{
                                            '& .MuiStepLabel-label': {
                                                fontSize: {
                                                    xs: '0.75rem',
                                                    sm: 'initial',
                                                },
                                            },
                                        }}
                                    >
                                        {label}
                                    </StepLabel>
                                </StepButton>
                            </Step>
                        )
                    })}
                </Stepper>

                {errorMessage && (
                    <Typography
                        sx={{
                            paddingRight: 4,
                            paddingLeft: 4,
                            paddingTop: 4,
                            paddingBottom: 0,
                        }}
                        color="error"
                        component="div"
                        gutterBottom
                    >
                        {errorMessage}
                    </Typography>
                )}

                {activeStep === 0 && (
                    <>
                        <DialogContent
                            sx={{
                                paddingRight: 4,
                                paddingLeft: 4,
                                paddingTop: 4,
                            }}
                        >
                            <Grid container spacing={4}>
                                <Grid item xs={12} sm={4}>
                                    <Typography
                                        variant="subtitle2"
                                        sx={{
                                            mb: 2,
                                            mt: 2,
                                            textTransform: 'uppercase',
                                            letterSpacing: 1,
                                            color: 'text.secondary',
                                        }}
                                    >
                                        Add Content
                                    </Typography>

                                    {activeInputPanel === 'shortTextImport' ? (
                                        <FormControl fullWidth sx={{ mb: 1.5 }}>
                                            <TextField
                                                label="Add Text, Keywords, or URLs Here"
                                                value={searchString}
                                                variant="outlined"
                                                onChange={
                                                    handleSearchStringChange
                                                }
                                                onBlur={() => {
                                                    // The voice menu owns the
                                                    // focus while it is open.
                                                    if (voiceMenuAnchor) return
                                                    if (
                                                        !searchString ||
                                                        searchString.length < 1
                                                    ) {
                                                        setActiveInputPanel(
                                                            false
                                                        )
                                                    }
                                                }}
                                                aria-describedby="searchString-helperText"
                                                multiline
                                                autoFocus
                                                rows={6}
                                                InputProps={{
                                                    endAdornment: voiceInputButton && (
                                                        <InputAdornment
                                                            position="end"
                                                            sx={{
                                                                alignSelf:
                                                                    'flex-end',
                                                                mb: 1,
                                                            }}
                                                        >
                                                            {voiceInputButton}
                                                        </InputAdornment>
                                                    ),
                                                }}
                                                sx={{
                                                    '& .MuiOutlinedInput-root': {
                                                        height: '180px',
                                                        '& .MuiInputBase-inputMultiline': {
                                                            height: '180px',
                                                            overflowY: 'auto',
                                                            padding:
                                                                '0 !important',
                                                            boxShadow:
                                                                'none !important',
                                                            border:
                                                                'none !important',
                                                        },
                                                    },
                                                }}
                                            />
                                        </FormControl>
                                    ) : (
                                        <Paper
                                            onClick={() =>
                                                openTextEditImport(
                                                    'shortTextImport'
                                                )
                                            }
                                            sx={{
                                                p: 1.5,
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: 1.5,
                                                backgroundColor:
                                                    'background.default',
                                                cursor: 'pointer',
                                                mb: 1.5,
                                                '&:hover': {
                                                    backgroundColor:
                                                        'action.hover',
                                                },
                                            }}
                                        >
                                            <TextFieldsIcon
                                                sx={{ color: '#0096ff' }}
                                            />
                                            <Box>
                                                <Typography variant="subtitle1">
                                                    Plain Text
                                                </Typography>
                                                <Typography
                                                    variant="body2"
                                                    color="text.secondary"
                                                >
                                                    Add plain text, keywords, or
                                                    paste URLs here
                                                </Typography>
                                            </Box>
                                            {voiceInputButton && (
                                                <Box
                                                    sx={{
                                                        ml: 'auto',
                                                        alignSelf: 'flex-end',
                                                    }}
                                                >
                                                    {voiceInputButton}
                                                </Box>
                                            )}
                                        </Paper>
                                    )}

                                    <Paper
                                        onClick={() =>
                                            openTextEditImport(
                                                'searchResultsImport'
                                            )
                                        }
                                        sx={{
                                            p: 1.5,
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 1.5,
                                            backgroundColor:
                                                'background.default',
                                            cursor: 'pointer',
                                            mb: 1.5,
                                            opacity: activeInputPanel ? 0.4 : 1,
                                            '&:hover': {
                                                backgroundColor: 'action.hover',
                                            },
                                        }}
                                    >
                                        <SearchIcon sx={{ color: '#0096ff' }} />
                                        <Box>
                                            <Typography variant="subtitle1">
                                                Search Results
                                            </Typography>
                                            <Typography
                                                variant="body2"
                                                color="text.secondary"
                                            >
                                                Import search engine and search
                                                intent results
                                            </Typography>
                                        </Box>
                                    </Paper>

                                    {/* <Paper
                                        onClick={() =>
                                            openTextEditImport('marketImport')
                                        }
                                        sx={{
                                            p: 1.5,
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 1.5,
                                            backgroundColor:
                                                'background.default',
                                            cursor: 'pointer',
                                            mb: 1.5,
                                            opacity: activeInputPanel ? 0.4 : 1,
                                            '&:hover': {
                                                backgroundColor: 'action.hover',
                                            },
                                        }}
                                    >
                                        <TrendingUpIcon
                                            sx={{ color: '#0096ff' }}
                                        />
                                        <Box>
                                            <Typography variant="subtitle1">
                                                Market Research
                                            </Typography>
                                            <Typography
                                                variant="body2"
                                                color="text.secondary"
                                            >
                                                Analyze market trends and data
                                            </Typography>
                                        </Box>
                                    </Paper> */}

                                    <Paper
                                        onClick={() =>
                                            openTextEditImport('pkmImport')
                                        }
                                        sx={{
                                            p: 1.5,
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 1.5,
                                            backgroundColor:
                                                'background.default',
                                            cursor: 'pointer',
                                            mb: 1.5,
                                            opacity: activeInputPanel ? 0.4 : 1,
                                            '&:hover': {
                                                backgroundColor: 'action.hover',
                                            },
                                        }}
                                    >
                                        <HubOutlinedIcon
                                            sx={{ color: '#0096ff' }}
                                        />
                                        <Box>
                                            <Typography variant="subtitle1">
                                                Knowledge Graph
                                            </Typography>
                                            <Typography
                                                variant="body2"
                                                color="text.secondary"
                                            >
                                                Create a knowledge graph
                                                manually with [[wiki links]]
                                            </Typography>
                                        </Box>
                                    </Paper>

                                    <Paper
                                        onClick={() =>
                                            openTextEditImport('aiGraphs')
                                        }
                                        sx={{
                                            p: 1.5,
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 1.5,
                                            backgroundColor:
                                                'background.default',
                                            cursor: 'pointer',
                                            mb: 1.5,
                                            opacity: activeInputPanel ? 0.4 : 1,
                                            '&:hover': {
                                                backgroundColor: 'action.hover',
                                            },
                                        }}
                                    >
                                        <AutoAwesomeIcon
                                            sx={{ color: '#0096ff' }}
                                        />
                                        <Box>
                                            <Typography variant="subtitle1">
                                                AI-Generated Graph
                                            </Typography>
                                            <Typography
                                                variant="body2"
                                                color="text.secondary"
                                            >
                                                Generate a knowledge graph for
                                                any topic with AI
                                            </Typography>
                                        </Box>
                                    </Paper>
                                </Grid>

                                <Grid item xs={12} sm={4}>
                                    <Typography
                                        variant="subtitle2"
                                        sx={{
                                            mb: 2,
                                            mt: 2,
                                            textTransform: 'uppercase',
                                            letterSpacing: 1,
                                            color: 'text.secondary',
                                        }}
                                    >
                                        Upload Files
                                    </Typography>

                                    <Paper
                                        onClick={() =>
                                            openTextEditImport(
                                                'textFilesImport'
                                            )
                                        }
                                        sx={{
                                            p: 1.5,
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 1.5,
                                            backgroundColor:
                                                'background.default',
                                            cursor: 'pointer',
                                            mb: 1.5,
                                            opacity:
                                                activeInputPanel ===
                                                'shortTextImport'
                                                    ? 0.4
                                                    : 1,
                                            '&:hover': {
                                                backgroundColor: 'action.hover',
                                            },
                                        }}
                                    >
                                        <UploadFileOutlinedIcon
                                            sx={{ color: '#17a93c' }}
                                        />
                                        <Box>
                                            <Typography variant="subtitle1">
                                                File Upload
                                            </Typography>
                                            <Typography
                                                variant="body2"
                                                color="text.secondary"
                                            >
                                                Upload .pdf, .json, .gexf,
                                                .docx, .rtf, or .txt files
                                            </Typography>
                                        </Box>
                                    </Paper>

                                    <Paper
                                        onClick={() =>
                                            openTextEditImport('csvFileImport')
                                        }
                                        sx={{
                                            p: 1.5,
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 1.5,
                                            backgroundColor:
                                                'background.default',
                                            cursor: 'pointer',
                                            mb: 1.5,
                                            opacity:
                                                activeInputPanel ===
                                                'shortTextImport'
                                                    ? 0.4
                                                    : 1,
                                            '&:hover': {
                                                backgroundColor: 'action.hover',
                                            },
                                        }}
                                    >
                                        <GridOnIcon sx={{ color: '#17a93c' }} />
                                        <Box>
                                            <Typography variant="subtitle1">
                                                CSV Import
                                            </Typography>
                                            <Typography
                                                variant="body2"
                                                color="text.secondary"
                                            >
                                                Import .csv and Google Sheets
                                                spreadsheet data
                                            </Typography>
                                        </Box>
                                    </Paper>
                                </Grid>

                                <Grid item xs={12} sm={4}>
                                    <Typography
                                        variant="subtitle2"
                                        sx={{
                                            mb: 2,
                                            mt: 2,
                                            textTransform: 'uppercase',
                                            letterSpacing: 1,
                                            color: 'text.secondary',
                                        }}
                                    >
                                        External Sources
                                    </Typography>

                                    {/* <Paper
                                        onClick={() =>
                                            openTextEditImport(
                                                'youtubeSubtitles'
                                            )
                                        }
                                        sx={{
                                            p: 1.5,
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 1.5,
                                            backgroundColor:
                                                'background.default',
                                            cursor: 'pointer',
                                            mb: 1.5,
                                            opacity:
                                                activeInputPanel ===
                                                'shortTextImport'
                                                    ? 0.4
                                                    : 1,
                                            '&:hover': {
                                                backgroundColor: 'action.hover',
                                            },
                                        }}
                                    >
                                        <OndemandVideoOutlinedIcon
                                            sx={{ color: '#FF0000' }}
                                        />
                                        <Box>
                                            <Typography variant="subtitle1">
                                                YouTube Videos
                                            </Typography>
                                            <Typography
                                                variant="body2"
                                                color="text.secondary"
                                            >
                                                Import subtitles and comments
                                                from YouTube
                                            </Typography>
                                        </Box>
                                    </Paper> */}
                                    {/* 
                                    <Paper
                                        onClick={() =>
                                            openTextEditImport('scholar')
                                        }
                                        sx={{
                                            p: 1.5,
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 1.5,
                                            backgroundColor:
                                                'background.default',
                                            cursor: 'pointer',
                                            mb: 1.5,
                                            opacity:
                                                activeInputPanel ===
                                                'shortTextImport'
                                                    ? 0.4
                                                    : 1,
                                            '&:hover': {
                                                backgroundColor: 'action.hover',
                                            },
                                        }}
                                    >
                                        <BiotechOutlinedIcon
                                            sx={{ color: '#1a73e8' }}
                                        />
                                        <Box>
                                            <Typography variant="subtitle1">
                                                Google Scholar
                                            </Typography>
                                            <Typography
                                                variant="body2"
                                                color="text.secondary"
                                            >
                                                Analyze scientific paper
                                                abstracts
                                            </Typography>
                                        </Box>
                                    </Paper> */}

                                    {/* <Paper
                                        onClick={() =>
                                            openTextEditImport('rss')
                                        }
                                        sx={{
                                            p: 1.5,
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 1.5,
                                            backgroundColor:
                                                'background.default',
                                            cursor: 'pointer',
                                            mb: 1.5,
                                            opacity: activeInputPanel ? 0.4 : 1,
                                            '&:hover': {
                                                backgroundColor: 'action.hover',
                                            },
                                        }}
                                    >
                                        <LanguageIcon
                                            sx={{ color: '#0096ff' }}
                                        />
                                        <Box>
                                            <Typography variant="subtitle1">
                                                News & RSS Feeds
                                            </Typography>
                                            <Typography
                                                variant="body2"
                                                color="text.secondary"
                                            >
                                                Extract content from RSS feeds
                                            </Typography>
                                        </Box>
                                    </Paper> */}

                                    <Paper
                                        onClick={() =>
                                            openTextEditImport('syncImport')
                                        }
                                        sx={{
                                            p: 1.5,
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 1.5,
                                            backgroundColor:
                                                'background.default',
                                            cursor: 'pointer',
                                            mb: 1.5,
                                            opacity:
                                                activeInputPanel ===
                                                'syncImport'
                                                    ? 0.4
                                                    : 1,
                                            '&:hover': {
                                                backgroundColor: 'action.hover',
                                            },
                                        }}
                                    >
                                        <CloudSyncOutlinedIcon
                                            sx={{ color: '#e50cd8' }}
                                        />
                                        <Box>
                                            <Typography variant="subtitle1">
                                                Sync & Import
                                            </Typography>
                                            <Typography
                                                variant="body2"
                                                color="text.secondary"
                                            >
                                                Obsidian, Evernote, RSS, URLs,
                                                etc.
                                            </Typography>
                                        </Box>
                                    </Paper>

                                    <Paper
                                        onClick={() => {
                                            setActiveSubImportDialog({})
                                            setActiveImportDialog(
                                                'shortTextImport'
                                            )
                                            sendToAnalytics({
                                                userId: username,
                                                event:
                                                    'choose_content_import_type',
                                                data: {
                                                    importType:
                                                        'shortTextImport',
                                                    source: 'otherSources',
                                                },
                                            })
                                        }}
                                        sx={{
                                            p: 1.5,
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 1.5,
                                            backgroundColor:
                                                'background.default',
                                            cursor: 'pointer',
                                            mb: 1.5,
                                            opacity:
                                                activeInputPanel ===
                                                'shortTextImport'
                                                    ? 0.4
                                                    : 1,
                                            '&:hover': {
                                                backgroundColor: 'action.hover',
                                            },
                                        }}
                                    >
                                        <HubOutlinedIcon
                                            sx={{ color: '#f57c00' }}
                                        />
                                        <Box>
                                            <Typography variant="subtitle1">
                                                All Other Sources
                                            </Typography>
                                            <Typography
                                                variant="body2"
                                                color="text.secondary"
                                            >
                                                AI, Web, YouTube, X, Amazon,
                                                etc.
                                            </Typography>
                                        </Box>
                                    </Paper>
                                </Grid>
                            </Grid>
                        </DialogContent>
                    </>
                )}

                {canDictate && (
                    <VoiceSourceMenu
                        keepFocus
                        anchorEl={voiceMenuAnchor}
                        open={!!voiceMenuAnchor}
                        onClose={() => setVoiceMenuAnchor(null)}
                        onSelect={handleVoiceSource}
                    />
                )}

                <DialogActions
                    sx={{
                        paddingRight: 4,
                        paddingLeft: 4,
                        paddingBottom: 4,
                        paddingTop: 2,
                    }}
                >
                    {/* <Button onClick={onClose} variant="outlined">
                        Cancel
                    </Button> */}

                    <LoadingButton
                        color="info"
                        variant="contained"
                        size="large"
                        endIcon={<ArrowForwardIcon />}
                        disabled={!searchString || !searchString.length > 0}
                        onClick={handleNext}
                        sx={{ px: 4, py: 1, fontSize: '0.95rem' }}
                    >
                        {activeStep === steps.length - 1 ? 'Visualize' : 'Next'}
                    </LoadingButton>
                </DialogActions>
            </Dialog>
        </>
    )
}
